function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M368 176c-8.832 0-16 7.168-16 16 0 88.224-71.776 160-160 160S32 280.224 32 192 103.776 32 192 32c42.952 0 83.272 16.784 113.544 47.264 6.216 6.272 16.352 6.312 22.624.08 6.272-6.224 6.304-16.352.08-22.624C291.928 20.144 243.536 0 192 0 86.128 0 0 86.128 0 192s86.128 192 192 192 192-86.128 192-192c0-8.832-7.168-16-16-16z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 176h-48v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h48c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
});

function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2);
}

export default SvgPlusCircle;